
import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData } from "../../../../apiservice/apis";
import { serviceExpenseDeleteApi } from "../../../../apiservice/service";

export const fetchServiceExpenseRecord = createAsyncThunk(
  "serviceExpenseRecord/fetch",
  async ({ selectedFilterType, selectedRecordType, filters }, { rejectWithValue }) => {
    try {
      let url = "/service/get-service-expense-record";
      if (selectedRecordType === "with item") {
        url = "/service/get-service-expense-record-with-details";
      }
      if (
        selectedFilterType &&
        ["By Item", "By Tag", "By Group", "By Category"].includes(selectedFilterType)
      ) {
        url = "/service/get-service-expense-details";
      }

      const payload = {
        selectedFilterType: selectedFilterType || null,
        selectedRecordType: selectedRecordType || null,
        locationId: selectedFilterType === "By Location" ? filters.locationId || null : null,
        supplierId: selectedFilterType === "By Supplier" ? filters.supplierId || null : null,
        // supplierId: selectedSupplier != null ? selectedSupplier.acc_id : null,
        employeeId: selectedFilterType === "By Employee" ? filters.employeeId || null : null,
        itemId: selectedFilterType === "By Item" ? filters.itemId || null : null,
        groupId: selectedFilterType === "By Group" ? filters.groupId || null : null,
        categoryId: selectedFilterType === "By Category" ? filters.categoryId || null : null,
        userId: selectedFilterType === "By User" ? filters.userId || null : null,
        serialNumber: selectedFilterType === "By Item Serial" ? filters.serialNumber || "" : "",
        tag_groupnameid: selectedFilterType === "By Tag" ? filters.tag_groupnameid || null : null,
        tagFeildNameid: selectedFilterType === "By Tag" ? filters.tagFeildNameid || null : null,
        fromDate: filters.fromDate || null,
        toDate: filters.toDate || null,
      };

      const res = await postData(url, payload);

      let mapped = [];
      if (selectedRecordType === "with item") {
        mapped = res.data.flatMap((serviceExpense) =>
          serviceExpense.details.map((item, idx) => {
            const total = Number(serviceExpense.total_amount || 0);
            const paid = Number(
              serviceExpense.paid_amount ||
              serviceExpense.paid_total ||
              0
            );
            const due = Number(
              serviceExpense.due_amount ||
              (total - paid)
            );

            return {
              id: `${serviceExpense.service_ex_id}-${item.item_id}-${idx}`,
              vch_no: serviceExpense.service_ex_voucher_no,
              date: serviceExpense.created_date,
              supplier: serviceExpense.acc_name,
              employee: serviceExpense.employee_name,
              createdBy: serviceExpense.full_name,
              mode: serviceExpense.trans?.map((t) => t.to_acc_name).join(", ") || "",
              item: item.item_name,
              rate: Number(item.item_rate || 0).toFixed(2),
              discount: item.item_discount_per ? `${item.item_discount_per}%` : "",
              vat: item.item_tax_per ? `${item.item_tax_per}%` : "",
              qty: `${item.item_qty} ${item.unit_name || ""}`,
              total: Number(item.item_total || 0).toFixed(2),

              // ✅ paid/due correctly mapped
              paid: paid.toFixed(2),
              due: due.toFixed(2),

              // Keep raw values for grand totals
              masterQty: Number(item.item_qty || 0),
              baseQty: Number(item.retail_qty || 0),

              unitDetails: `Total : Master U. Qty = ${item.item_qty || 0}, Base U. Qty = ${item.retail_qty || 0}`,
            };
          })
        );
      } else {
        mapped = res.data.map((row) => {
          const total = Number(row.total_amount || 0);
          const paid = Number(
            row.paid_amount ||
            row.paid_total ||
            0
          );
          const due = Number(
            row.due_amount ||
            (total - paid)
          );

          return {
            id: row.service_ex_id,
            vch_no: row.service_ex_voucher_no,
            date: row.created_date,
            supplier: row.acc_name,
            employee: row.employee_name,
            createdBy: row.full_name,
            mode: row.trans?.map((t) => t.to_acc_name).join(", ") || "",
            subtotal: Number(row.sub_total || 0).toFixed(2),
            discount: Number(row.total_discount || 0).toFixed(2),
            vat: Number(row.total_tax || 0).toFixed(2),
            service: Number(row.other_service_cost || 0).toFixed(2),
            total: total.toFixed(2),
            paid: paid.toFixed(2),
            due: due.toFixed(2),
            cgst_amount: row.cgst_amount,
            sgst_amount: row.sgst_amount,
            igst_amount: row.igst_amount,
          };
        });
      }


      return mapped;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const deleteServiceExpense = createAsyncThunk(
  "serviceExpenseRecord/delete",
  async (service_ex_id, { rejectWithValue }) => {
    try {
      const res = await serviceExpenseDeleteApi({
        service_ex_id,
      });
      return { service_ex_id, message: res.data.message };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

